module.exports = require('./readable').PassThrough



//////////////////
// WEBPACK FOOTER
// ./~/readable-stream/passthrough.js
// module id = 1251
// module chunks = 44